<template>
  <div class="brush-palette clearfix">
    <div v-for="(idx, brush) in state.AVAILABLE_BRUSHES"
         class="palette-button brush-palette-item"
         data-cmd="setBrush" data-arg="{{ idx }}">
      <div class="brush-icon brush-icon-idx" v-bind:style="{'background-position': brush.backgroundPosition}" ></div>
    </div>
  </div>
</template>

<style lang="scss">

  $w: 40px;

  .brush-palette {
    width: $w * 6;
  }

  .brush-palette-item {
    width: 40px;
    height: 30px;

    .brush-icon {
      margin: 5px 10px;
    }
  }

</style>

<script>
  import state from '../../data/state';

  export default{
    data(){
      return {
        state
      }
    },

  }
</script>



// WEBPACK FOOTER //
// Brushes.vue?306a2278